/**
 * AI画像生成 共通定数
 */
import {
  AICharacter,
  AIStyle,
  AIExpression,
  AIAccessory,
  AIBackground,
  AICharacterConfig,
  AIStyleConfig,
  AIOptionConfig,
} from "./types";

// ============================================================
// AI生成オプション
// ============================================================

export const AI_CHARACTERS: AICharacterConfig[] = [
  { key: AICharacter.CAT, labelKey: "MSG_AI_PRESET_CAT", icon: "pets" },
  { key: AICharacter.DOG, labelKey: "MSG_AI_PRESET_DOG", icon: "pets" },
  { key: AICharacter.RABBIT, labelKey: "MSG_AI_PRESET_RABBIT", icon: "cruelty_free" },
  { key: AICharacter.BEAR, labelKey: "MSG_AI_PRESET_BEAR", icon: "nature_people" },
  { key: AICharacter.BIRD, labelKey: "MSG_AI_PRESET_BIRD", icon: "flutter" },
  { key: AICharacter.NINJA, labelKey: "MSG_AI_PRESET_NINJA", icon: "person" },
  { key: AICharacter.WIZARD, labelKey: "MSG_AI_PRESET_WIZARD", icon: "auto_fix_high" },
  { key: AICharacter.ROBOT, labelKey: "MSG_AI_PRESET_ROBOT", icon: "smart_toy" },
];

export const AI_STYLES: AIStyleConfig[] = [
  { key: AIStyle.CYBERPUNK, labelKey: "MSG_AI_STYLE_CYBERPUNK", icon: "bolt" },
  { key: AIStyle.ANIME, labelKey: "MSG_AI_STYLE_ANIME", icon: "animation" },
  { key: AIStyle.DRAMATIC, labelKey: "MSG_AI_STYLE_DRAMATIC", icon: "photo_camera" },
  { key: AIStyle.COLORING, labelKey: "MSG_AI_STYLE_COLORING", icon: "draw" },
  { key: AIStyle.PHOTO, labelKey: "MSG_AI_STYLE_PHOTO", icon: "camera" },
  { key: AIStyle.RETRO_MANGA, labelKey: "MSG_AI_STYLE_RETRO_MANGA", icon: "menu_book" },
  { key: AIStyle.EIGHTIES, labelKey: "MSG_AI_STYLE_EIGHTIES", icon: "nightlife" },
  { key: AIStyle.ART_NOUVEAU, labelKey: "MSG_AI_STYLE_ART_NOUVEAU", icon: "spa" },
  { key: AIStyle.SYNTHWAVE, labelKey: "MSG_AI_STYLE_SYNTHWAVE", icon: "graphic_eq" },
];

export const AI_EXPRESSIONS: AIOptionConfig[] = [
  { key: AIExpression.SMILE, labelKey: "MSG_AI_EXPRESSION_SMILE" },
  { key: AIExpression.COOL, labelKey: "MSG_AI_EXPRESSION_COOL" },
  { key: AIExpression.SLEEPY, labelKey: "MSG_AI_EXPRESSION_SLEEPY" },
  { key: AIExpression.SURPRISED, labelKey: "MSG_AI_EXPRESSION_SURPRISED" },
];

export const AI_ACCESSORIES: AIOptionConfig[] = [
  { key: AIAccessory.HAT, labelKey: "MSG_AI_ACCESSORY_HAT" },
  { key: AIAccessory.GLASSES, labelKey: "MSG_AI_ACCESSORY_GLASSES" },
  { key: AIAccessory.RIBBON, labelKey: "MSG_AI_ACCESSORY_RIBBON" },
  { key: AIAccessory.CROWN, labelKey: "MSG_AI_ACCESSORY_CROWN" },
];

export const AI_BACKGROUNDS: AIOptionConfig[] = [
  { key: AIBackground.STARRY, labelKey: "MSG_AI_BACKGROUND_STARRY" },
  { key: AIBackground.MEADOW, labelKey: "MSG_AI_BACKGROUND_MEADOW" },
  { key: AIBackground.SPACE, labelKey: "MSG_AI_BACKGROUND_SPACE" },
  { key: AIBackground.FLOWER, labelKey: "MSG_AI_BACKGROUND_FLOWER" },
];
